export default {"src":"/_next/static/media/diamond-w-image-icon.4a14a7de.svg","height":17,"width":17};